import React from "react";
import { Link } from "react-router-dom";
// import hero from '../Assets/hero.png'
import courtroom from "../Assets/IMG_00.png";

const HomePage: React.FC = () => {
  return (
    <div>
      <div
        className="text-white h-[674px] w-full px-3 md:px-20 pt-40 bg-cover bg-center"
        style={{ backgroundImage: `url(${courtroom})` }}
      >
        <div className="flex flex-col justify-center md:px-10 pt-10 h-hug gap-[30px]">
          <h3 className="text-[18px] md:text-[29px] font-bold">TELE COURT</h3>
          <p className="text-[16px] md:text-[29px] leading-snug">
            Tele Court is a pioneering technological platform designed to bridge
            the gap between traditional justice systems and the evolving needs
            of modern society. Our mission is to democratize access to justice
            by providing a secure, efficient, and affordable remote
            court experience.
          </p>
          <div className="flex gap-3 text-[16px] md:text-[25px]">
            <Link
              to={"/register"}
              className="rounded-sm md:rounded-lg md:px-4 p-1 bg-lightbrown text-white"
            >
              Get started
            </Link>
            {/* <Link to={'/login'} className="border border-lightbrown rounded-sm md:rounded-lg px-4 py-1">Login</Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomePage;
